import React from 'react';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

const ProjectCard = ({ project, index }) => {
  // Create tags array from the three properties
  const tags = [
    { type: 'stage', value: project.stage },
    { type: 'commodity', value: project.commodity },
    { type: 'location', value: project.location }
  ];

  return (
    <div className="cardWrapper">
      <div className="topContainer">
        <p className="projectIndex">{index + 1}</p>
        <div className="imageCardWrapper">
          <span className="backImage">
            <img src="/project.webp" alt="Project" width="45" height="45" />
          </span>
        </div>
        <div className="tagsWrapper">
          {tags.map((tag, index) => (
            <span key={index} className={`tagPreview ${tag.type}`}>
              {tag.value}
            </span>
          ))}
        </div>
      </div>
      <div className="bottomContainer">
        <h1 className="projectName">{project.project_name}</h1>
        <p className="descriptionText">{project.description}</p>
        <Link to={`/project/${project.project_id}`} className="viewProjectBtn">
          View Project <span className="iconWrapper"></span>
        </Link>
      </div>
    </div>
  );
};

export default ProjectCard; 